import { ArrowRight, MapPin } from "lucide-react";
import { CORRIDORS, waLink } from "@/config/brand";
import { MEDIA } from "@/config/media";
import { Reveal, SectionLabel } from "./Reveal";

export const Corridors = () => (
  <section id="corridors" data-testid="corridors-section" className="bg-white py-20 lg:py-28">
    <div className="mx-auto max-w-[1280px] px-5 lg:px-8">
      <Reveal>
        <SectionLabel index="01">Where we advise</SectionLabel>
        <div className="mt-5 flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <h2 className="max-w-2xl font-display text-3xl font-extrabold leading-tight text-ink sm:text-4xl">
            Three townships on NH-24, compared side by side
          </h2>
          <p className="max-w-sm text-base text-body">
            We advise only on the Ghaziabad stretch of the Delhi–Meerut Expressway — that focus is
            what makes the advice specific.
          </p>
        </div>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
        {CORRIDORS.map((c, i) => (
          <Reveal key={c.key} delay={i * 0.08}>
            <article
              data-testid={`corridor-card-${c.key}`}
              className="card-soft card-hover group flex h-full flex-col overflow-hidden"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={MEDIA[c.key]}
                  alt={c.label}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-white/95 px-3 py-1.5 text-xs font-semibold text-ink">
                  <MapPin className="h-3.5 w-3.5 text-brand" /> {c.label}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6">
                <p className="text-sm leading-relaxed text-body">{c.blurb}</p>
                <dl className="mt-5 space-y-2.5 border-t border-line pt-5">
                  {c.stats.map((s) => (
                    <div key={s.k} className="flex items-center justify-between gap-4">
                      <dt className="text-xs text-muted2">{s.k}</dt>
                      <dd className="text-xs font-semibold text-ink">{s.v}</dd>
                    </div>
                  ))}
                </dl>
                <a
                  href={waLink(`Hi BRICKSPACE, I want inventory options in ${c.label}.`)}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={i === 0 ? "corridor-whatsapp-btn" : `corridor-whatsapp-${c.key}`}
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-brand transition-all hover:gap-2.5"
                >
                  See live inventory <ArrowRight className="h-4 w-4" />
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
